import { registerToolRendererGroup } from "../util/shapeCategorySingleton";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { hitStrokeCorrection, strokeCorrection } from "../util/strokeCorrection";
import { angleOfTwoLinesFromThreePoints, pointEquals } from "../../../geometry/operation";
import { RootState } from "../../../store/store";
import { modelReplaceMultipleShapes } from "../../../store/model";
import { Transform } from "../../../geometry/transformation";
import { endRubberline } from "../../../store/interaction";
import BaseLine from "../shapes/line/LineBase";
import RenderSelection from "../util/RenderSelection";
import { useSnapMousePosition } from "./useSnapMousePosition";
import { transformShape } from "../util/shapeEdit";

const RotationSymbol = () => {

  const dispatch = useAppDispatch();
  const selectionIds = useAppSelector((state: RootState) => state.model.present.selected.selectedItemIds)
  const shapes = useAppSelector((state: RootState) => state.model.present.model.shapes);
  const interaction = useAppSelector((state: RootState) => state.interaction)
  const scale = useAppSelector((state: RootState) => state.interface.viewport.scale)
  const mousePosition = useAppSelector((state: RootState) => state.interface.mousePosition);
  const defaultSetting = useAppSelector((state: RootState) => state.tool.toolSettings.rotation.symbolLine);
  const selectedShapes = shapes.filter((shape: GeometricShape) => selectionIds.find((selectionId) => shape.id === selectionId) !== undefined);
  const mousePositionSnap = useSnapMousePosition();


  // Modify Line properties for use of rotation symbol
  const internalLineProperties = {
    ...defaultSetting,
    id: -1,
    strokeWidth: strokeCorrection(defaultSetting.strokeWidth, scale),
    points: interaction.rubberlineData.snapPoints.concat(mousePositionSnap),
    hitStrokeWidth: hitStrokeCorrection(defaultSetting.hitStrokeWidth, defaultSetting.hitStrokeWidth, scale),
    closed: false,
  }

  // Points coming from clicks on the stage
  const pointBuffer = interaction.rubberlineData.snapPoints;

  const angle = (pointBuffer[0] && pointBuffer[1] && mousePosition && !pointEquals(pointBuffer[0], mousePosition)) ?
    angleOfTwoLinesFromThreePoints(pointBuffer[0], pointBuffer[1], mousePositionSnap) :
    0;

  const rotationTransformation = pointBuffer[0] && !pointEquals(pointBuffer[0], mousePosition) ?
    new Transform()
      .translate(-pointBuffer[0].x, -pointBuffer[0].y)
      .rotate(angle)
      .translate(pointBuffer[0].x, pointBuffer[0].y) :
    new Transform();

  switch (pointBuffer.length) {

    // Before the first click, when rotation selcted
    case 0:
      break;

    // First click makes a line to symbolise the starting point of rotation
    case 1: {
      return (
        <BaseLine
          shapeProps={internalLineProperties} />
      );
    }

    // Second click, anoter line to show angle of rotation
    case 2: {
      return (
        <>
          <BaseLine shapeProps={{
            ...internalLineProperties,
            points: [pointBuffer[1], pointBuffer[0], mousePositionSnap]
          }} />
          <RenderSelection selectedItems={selectedShapes} transform={rotationTransformation} />
        </>
      );
    }

    // Third click finalize editing
    case 3: {
      if (selectedShapes) {
        const newShapeList = selectedShapes.map((shape) => transformShape(shape, rotationTransformation))
        dispatch(modelReplaceMultipleShapes(newShapeList))
        dispatch(endRubberline());
      }
      break;
    }
    default:
      break;
  }
  return <></>
}
// Making the function and registeing it to the central storage singleton
const createRotationSymbol = () => {
  return (
    <RotationSymbol />
  )
}
registerToolRendererGroup("rotation", { toolRender: createRotationSymbol })

export default RotationSymbol;